import useTranslations from "@/i18n/useTranslations";
interface FormattedPriceProps {
  discountedPrice: number;
  originalPrice?: number;
  currency?: string;
  variant?: string;
}

function FormattedPrice({
  discountedPrice,
  originalPrice,
  currency,
  variant,
}: FormattedPriceProps) {
  const t = useTranslations("Common");
  const priceFormat = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency || "USD",
    minimumFractionDigits: 2,
  });

  if (!originalPrice || discountedPrice === originalPrice) {
    return (
      <span
        className={`whitespace-nowrap ${variant === "light" ? "text-white" : ""}`}
      >{`${priceFormat.format(discountedPrice)} ${currency}`}</span>
    );
  }

  return (
    <>
      <span className={`font-bold ${variant === "light" ? "text-white" : ""}`}>
        <span className="sr-only">{t("discountedPrice")}</span>
        {priceFormat.format(discountedPrice)}
      </span>
      <span
        className={`font-normal line-through whitespace-nowrap ${variant === "light" ? "text-secondary-300" : ""}`}
      >
        <span className="sr-only">{t("originalPrice")}</span>
        {priceFormat.format(originalPrice)}
      </span>
      <span className="font-bold">{` ${currency}`}</span>
    </>
  );
}

export default FormattedPrice;
